// // src/pages/NotFound.jsx
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./notfound.css";

// const NotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="nf-container">
//       <h1 className="nf-404">404</h1>
//       <h2>Page Not Found</h2>
//       <p>Oops! The page you are looking for doesn’t exist.</p>

//       <button onClick={() => navigate("/")}>
//         Go Home
//       </button>
//     </div>
//   );
// };

// export default NotFound;


// import React from "react";
// import Lottie from "lottie-react";
// import animationData from "./Error 404.json"; // download json
// import { useNavigate } from "react-router-dom";

// const NotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <div style={{ textAlign: "center", marginTop: "50px" }}>
//       <Lottie animationData={animationData} style={{ height: 500 }} />

//       <button onClick={() => navigate("/")}>
//         Go Home
//       </button>
//     </div>
//   );
// };

// export default NotFound;



import React from "react";
import Lottie from "lottie-react";
import animationData from "./Error 404.json";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <Lottie animationData={animationData} style={{ height: 420 }} />

      <button
        style={styles.button}
        onClick={() => navigate("/")}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(-3px) scale(1.05)";
          e.target.style.boxShadow = "0 12px 25px rgba(106, 27, 154, 0.4)";
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(0) scale(1)";
          e.target.style.boxShadow = "0 6px 15px rgba(0,0,0,0.2)";
        }}
      >
        ⬅ Back to Home
      </button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    marginTop: "40px",
  },

  button: {
    marginTop: "20px",
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#fff",

    // 🎨 matched with animation colors
    background: "linear-gradient(135deg, #e35d6a, #6a1b9a)",

    border: "none",
    borderRadius: "50px",
    cursor: "pointer",

    // soft shadow
    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",

    transition: "all 0.3s ease",
    letterSpacing: "0.5px",
  },
};

export default NotFound;